import { createElement } from 'react'
import { createRoot } from 'react-dom/client'

const mountedRoots = new Map()

const isRenderFunction = (component) => (
  typeof component === 'function' &&
  !component.prototype?.isReactComponent &&
  Boolean(component.renderFunction || component.length >= 2)
)

const unmountEntry = (domNodeId, entry) => {
  if (mountedRoots.get(domNodeId) === entry) mountedRoots.delete(domNodeId)
  if (entry.unmounted) return
  entry.root.unmount()
  entry.unmounted = true
}

export function withTrackedRoot (component) {
  if (isRenderFunction(component)) return component

  return (props, _railsContext, domNodeId) => {
    unmountDetachedRoots()

    const domNode = document.getElementById(domNodeId)
    const root = createRoot(domNode)
    const entry = { domNode, root, unmounted: false }

    mountedRoots.set(domNodeId, entry)
    root.render(createElement(component, props))

    return { teardown: () => unmountEntry(domNodeId, entry) }
  }
}

const unmountMatching = (predicate) => {
  Array.from(mountedRoots).forEach(([domNodeId, entry]) => {
    if (!predicate(entry)) return

    try {
      unmountEntry(domNodeId, entry)
    } catch (e) {
      console.error(`Error unmounting React root "${domNodeId}":`, e)
    }
  })
}

export function unmountRootsWithin (container) {
  unmountMatching((entry) => container.contains(entry.domNode))
}

export function unmountDetachedRoots () {
  unmountMatching((entry) => !entry.domNode.isConnected)
}
